import type {Constant, Val} from 'schemaDefinition/types';

export const isConstantSingleValue = (value: Val): value is Constant =>
  typeof value === 'number' ||
  typeof value === 'string' ||
  typeof value === 'boolean' ||
  value === null;
